/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateAnhang } from '../models/CreateAnhang';
import type { Dublette } from '../models/Dublette';
import type { EingangsrechnungenBadge } from '../models/EingangsrechnungenBadge';
import type { EingangsrechnungInfo } from '../models/EingangsrechnungInfo';
import type { Rechnung } from '../models/Rechnung';
import type { RechnungDaten } from '../models/RechnungDaten';
import type { RechnungenListe } from '../models/RechnungenListe';
import type { RechnungsAnhang } from '../models/RechnungsAnhang';
import type { UpdateZugewieseneRechnungBaustelleDaten } from '../models/UpdateZugewieseneRechnungBaustelleDaten';
import type { ZugewieseneRechnungBaustelle } from '../models/ZugewieseneRechnungBaustelle';
import type { ZugewieseneRechnungBaustelleDaten } from '../models/ZugewieseneRechnungBaustelleDaten';
import type { ZugewieseneRechnungBaustellenListe } from '../models/ZugewieseneRechnungBaustellenListe';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class RechnungenService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns RechnungenListe Liste der Rechnungen
   * @throws ApiError
   */
  public sucheRechnungen({
    search,
    status,
    pruefer,
    filtered,
    page,
    limit,
    sort,
  }: {
    search?: string,
    status?: string,
    pruefer?: string,
    filtered?: string,
    page?: number,
    limit?: number,
    sort?: string,
  }): CancelablePromise<RechnungenListe> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/rechnungen',
      query: {
        'search': search,
        'status': status,
        'pruefer': pruefer,
        'filtered': filtered,
        'page': page,
        'limit': limit,
        'sort': sort,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * @returns Rechnung die angelegte Rechnung
   * @throws ApiError
   */
  public createRechnung({
    requestBody,
  }: {
    requestBody: RechnungDaten,
  }): CancelablePromise<Rechnung> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/rechnungen',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * @returns RechnungenListe Liste der Rechnungen gefiltert auf Eingangsrechnungen
   * @throws ApiError
   */
  public sucheEingangsrechnungen({
    search,
    status,
    zahllauf,
    zahllaufBezahlt,
    filtered,
    page,
    limit,
    sort,
  }: {
    search?: string,
    status?: string,
    zahllauf?: string,
    zahllaufBezahlt?: boolean,
    filtered?: string,
    page?: number,
    limit?: number,
    sort?: string,
  }): CancelablePromise<RechnungenListe> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/eingangsrechnungen',
      query: {
        'search': search,
        'status': status,
        'zahllauf': zahllauf,
        'zahllaufBezahlt': zahllaufBezahlt,
        'filtered': filtered,
        'page': page,
        'limit': limit,
        'sort': sort,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * @returns Rechnung Rechnung
   * @throws ApiError
   */
  public getRechnung({
    rechnungId,
  }: {
    rechnungId: string,
  }): CancelablePromise<Rechnung> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/rechnungen/{rechnungId}',
      path: {
        'rechnungId': rechnungId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * @returns Rechnung die aktualisierte Rechnung
   * @throws ApiError
   */
  public updateRechnung({
    rechnungId,
    requestBody,
  }: {
    rechnungId: string,
    requestBody: RechnungDaten,
  }): CancelablePromise<Rechnung> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/rechnungen/{rechnungId}',
      path: {
        'rechnungId': rechnungId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * @returns Rechnung die gelöschte Rechnung
   * @throws ApiError
   */
  public deleteRechnung({
    rechnungId,
  }: {
    rechnungId: string,
  }): CancelablePromise<Rechnung> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/rechnungen/{rechnungId}',
      path: {
        'rechnungId': rechnungId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * @returns Dublette Dubelettenpruefung
   * @throws ApiError
   */
  public getRechnungsDublette({
    rechnungId,
    rechnungsNummer,
    lieferantenId,
  }: {
    rechnungId: string,
    rechnungsNummer?: string,
    lieferantenId?: string,
  }): CancelablePromise<Dublette> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/rechnungen/{rechnungId}/duplicate-check',
      path: {
        'rechnungId': rechnungId,
      },
      query: {
        'rechnungsNummer': rechnungsNummer,
        'lieferantenId': lieferantenId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * @returns void
   * @throws ApiError
   */
  public saveAndResendDatev({
    rechnungId,
    requestBody,
  }: {
    rechnungId: string,
    requestBody: RechnungDaten,
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/rechnungen/{rechnungId}/datev/resend',
      path: {
        'rechnungId': rechnungId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @returns RechnungsAnhang das angelegte Rechnungsanhang
   * @throws ApiError
   */
  public createRechnungsAnhang({
    formData,
  }: {
    formData: CreateAnhang,
  }): CancelablePromise<RechnungsAnhang> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/rechnungen/anhaenge',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * @returns ZugewieseneRechnungBaustellenListe Liste der zugewiesenen Baustellen
   * @throws ApiError
   */
  public getZugewieseneBaustellen({
    rechnungsId,
    search,
    page,
    limit,
    sort,
  }: {
    rechnungsId: string,
    search?: string,
    page?: number,
    limit?: number,
    sort?: string,
  }): CancelablePromise<ZugewieseneRechnungBaustellenListe> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/rechnungen/{rechnungsId}/zugewiesene-baustellen',
      path: {
        'rechnungsId': rechnungsId,
      },
      query: {
        'search': search,
        'page': page,
        'limit': limit,
        'sort': sort,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * @returns ZugewieseneRechnungBaustelle die zugewiesene Baustelle
   * @throws ApiError
   */
  public assignBaustelleZuRechnung({
    rechnungsId,
    requestBody,
    rechnungBeglichenAm,
  }: {
    rechnungsId: string,
    requestBody: ZugewieseneRechnungBaustelleDaten,
    rechnungBeglichenAm?: string,
  }): CancelablePromise<ZugewieseneRechnungBaustelle> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/rechnungen/{rechnungsId}/zugewiesene-baustellen',
      path: {
        'rechnungsId': rechnungsId,
      },
      query: {
        'rechnungBeglichenAm': rechnungBeglichenAm,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * @returns ZugewieseneRechnungBaustelle die zugewiesene Baustelle
   * @throws ApiError
   */
  public getZugewieseneBaustelle({
    rechnungsId,
    zugewieseneBaustellenId,
  }: {
    rechnungsId: string,
    zugewieseneBaustellenId: string,
  }): CancelablePromise<ZugewieseneRechnungBaustelle> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/rechnungen/{rechnungsId}/zugewiesene-baustellen/{zugewieseneBaustellenId}',
      path: {
        'rechnungsId': rechnungsId,
        'zugewieseneBaustellenId': zugewieseneBaustellenId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @returns ZugewieseneRechnungBaustelle die aktualisierte zugewiesene Baustelle
   * @throws ApiError
   */
  public updateZugewieseneBaustelle({
    rechnungsId,
    zugewieseneBaustellenId,
    requestBody,
    rechnungBeglichenAm,
  }: {
    rechnungsId: string,
    zugewieseneBaustellenId: string,
    requestBody: UpdateZugewieseneRechnungBaustelleDaten,
    rechnungBeglichenAm?: string,
  }): CancelablePromise<ZugewieseneRechnungBaustelle> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/rechnungen/{rechnungsId}/zugewiesene-baustellen/{zugewieseneBaustellenId}',
      path: {
        'rechnungsId': rechnungsId,
        'zugewieseneBaustellenId': zugewieseneBaustellenId,
      },
      query: {
        'rechnungBeglichenAm': rechnungBeglichenAm,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * @returns ZugewieseneRechnungBaustelle die gelöschte zugewiesene Baustelle
   * @throws ApiError
   */
  public deleteZugewieseneBaustelle({
    rechnungsId,
    zugewieseneBaustellenId,
  }: {
    rechnungsId: string,
    zugewieseneBaustellenId: string,
  }): CancelablePromise<ZugewieseneRechnungBaustelle> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/rechnungen/{rechnungsId}/zugewiesene-baustellen/{zugewieseneBaustellenId}',
      path: {
        'rechnungsId': rechnungsId,
        'zugewieseneBaustellenId': zugewieseneBaustellenId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Durchsuche alle zuweisbaren Eingangsrechnungen
   * @returns RechnungenListe Die Seite der zuweisbaren Eingangsrechnungen
   * @throws ApiError
   */
  public sucheZuweisbareEingangsrechnungen({
    korrekturRechnungId,
    korrekturBelegTyp,
    search,
    lieferantId,
    bruttoBetrag,
    startDate,
    endDate,
    page,
    limit,
    sort,
  }: {
    korrekturRechnungId: string,
    korrekturBelegTyp?: string,
    search?: string,
    lieferantId?: string,
    bruttoBetrag?: number,
    startDate?: string,
    endDate?: string,
    page?: number,
    limit?: number,
    sort?: string,
  }): CancelablePromise<RechnungenListe> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/buchungskorrektur/{korrekturRechnungId}',
      path: {
        'korrekturRechnungId': korrekturRechnungId,
      },
      query: {
        'korrekturBelegTyp': korrekturBelegTyp,
        'search': search,
        'lieferantId': lieferantId,
        'bruttoBetrag': bruttoBetrag,
        'startDate': startDate,
        'endDate': endDate,
        'page': page,
        'limit': limit,
        'sort': sort,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * @returns Rechnung Die aktualisierte Korrektur Rechnung.
   * @throws ApiError
   */
  public korrekturRechnungZuweisen({
    korrekturRechnungId,
    korrekturBelegTyp,
    rechnungId,
  }: {
    korrekturRechnungId: string,
    korrekturBelegTyp?: string,
    rechnungId?: string,
  }): CancelablePromise<Rechnung> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/buchungskorrektur/{korrekturRechnungId}',
      path: {
        'korrekturRechnungId': korrekturRechnungId,
      },
      query: {
        'korrekturBelegTyp': korrekturBelegTyp,
        'rechnungId': rechnungId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * @returns EingangsrechnungenBadge Die Anzahl der Eingangsrechnungen in Pruefung
   * @throws ApiError
   */
  public getEingangsrechnungenInPruefungBadge(): CancelablePromise<EingangsrechnungenBadge> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/eingangsrechungen/badge',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * @returns EingangsrechnungInfo Eingangsrechnung
   * @throws ApiError
   */
  public getEingangsrechnung({
    rechnungId,
  }: {
    rechnungId: string,
  }): CancelablePromise<EingangsrechnungInfo> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/eingangsrechungen/{rechnungId}',
      path: {
        'rechnungId': rechnungId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

}
